(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["avelavale-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const header = document.querySelector('[data-avelavale-header]');
    if (!header) return;
    const menuButton = header.querySelector('.av-header__menu');
    const mobileNav = header.querySelector('.av-mobile-nav');
    if (menuButton && mobileNav) {
      menuButton.addEventListener('click', () => {
        const open = menuButton.getAttribute('aria-expanded') === 'true';
        menuButton.setAttribute('aria-expanded', String(!open));
        mobileNav.hidden = open;
      });
    }
    const base = header.dataset.externalCheckoutBase?.trim();
    const template = header.dataset.externalCheckoutParams?.trim();
    if (!base || !template) return;
    const query = new URLSearchParams(window.location.search);
    const attributionKeys = ['clickid', 'pid', 'sub2', 'sub4', 'sub5'];
    attributionKeys.forEach((key) => {
      const value = query.get(key);
      if (value) sessionStorage.setItem(`avelavale_${key}`, value);
    });
    const productDataElement = document.querySelector('[data-avelavale-product-data]');
    let productData = null;
    if (productDataElement) {
      try {
        productData = JSON.parse(productDataElement.textContent);
      } catch (error) {
        productData = null;
      }
    }
    const selectedVariant = () => {
      if (!productData?.variants?.length) return null;
      const checked = document.querySelector('form[action*="/cart/add"] [name="id"]:checked');
      const input = checked || document.querySelector('form[action*="/cart/add"] [name="id"]');
      const variantId = input?.value || query.get('variant');
      return productData.variants.find((variant) => String(variant.id) === String(variantId)) || productData.variants[0];
    };
    const checkoutValues = () => {
      const variant = selectedVariant();
      const productName = productData?.title || header.dataset.productName || document.querySelector('h1')?.textContent?.trim() || document.querySelector('.cart-item__name')?.textContent?.trim() || document.title.split('–')[0].trim();
      const variantTitle = variant?.title || header.dataset.variantTitle || '';
      const productImage = variant?.image || productData?.featuredImage || header.dataset.productImage || document.querySelector('meta[property="og:image"]')?.content || document.querySelector('.cart-item__image')?.src || '';
      return {
        clickid: query.get('clickid') || sessionStorage.getItem('avelavale_clickid') || '{clickid}',
        pid: query.get('pid') || sessionStorage.getItem('avelavale_pid') || '{pid}',
        sub2: query.get('sub2') || sessionStorage.getItem('avelavale_sub2') || '{sub2}',
        sub4: query.get('sub4') || sessionStorage.getItem('avelavale_sub4') || '{sub4}',
        sub5: query.get('sub5') || sessionStorage.getItem('avelavale_sub5') || '{sub5}',
        shopify_name: productName,
        variant: variantTitle === 'Default Title' ? '' : variantTitle,
        varient: variantTitle === 'Default Title' ? '' : variantTitle,
        shopify_image_variant: productImage,
        shopify_image_varient: productImage
      };
    };
    const destination = () => {
      const values = checkoutValues();
      let parameters = template.replace(/\{(clickid|pid|sub2|sub4|sub5|shopify_name|variant|varient|shopify_image_variant|shopify_image_varient)\}/g, (_, key) => {
        const value = values[key] || '';
        if (attributionKeys.includes(key) && value === `{${key}}`) return value;
        return encodeURIComponent(value);
      });
      if (base.includes('?') && parameters.startsWith('?')) parameters = `&${parameters.slice(1)}`;
      if (!base.includes('?') && !parameters.startsWith('?')) parameters = `?${parameters.replace(/^&/, '')}`;
      return `${base}${parameters}`;
    };
    const go = (event) => {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      window.location.assign(destination());
    };
    document.addEventListener('click', (event) => {
      const checkoutTrigger = event.target.closest('[name="checkout"], a[href="/checkout"], a[href*="/checkout?"], .cart__checkout-button');
      const productTrigger = productData && event.target.closest('.product-form__submit, .av-product__submit, #StickyATCButton, .shopify-payment-button__button');
      if (checkoutTrigger || productTrigger) go(event);
    }, true);
    document.addEventListener('submit', (event) => {
      const submitter = event.submitter;
      const checkoutForm = submitter?.name === 'checkout' || event.target.matches('form[action="/checkout"]');
      const directProductForm = productData && event.target.matches('form[action*="/cart/add"]') && event.target.querySelector('.product-form__submit, .av-product__submit');
      if (checkoutForm || directProductForm) go(event);
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avelavale-product"]) return;
  try {
    
  document.querySelectorAll('[data-av-product]').forEach((root) => {
    const select = root.querySelector('[data-av-variant]');
    const current = root.querySelector('.av-product__current-price');
    const compare = root.querySelector('.av-product__compare-price');
    if (select) select.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      current.textContent = option.dataset.price || '';
      if (option.dataset.compare) { compare.textContent = option.dataset.compare; compare.hidden = option.dataset.compare === option.dataset.price; } else { compare.hidden = true; }
      if (option.dataset.image) { const firstImage = root.querySelector('[data-av-image] img'); if (firstImage) firstImage.src = option.dataset.image; }
    });
    const quantity = root.querySelector('[data-av-quantity]');
    root.querySelectorAll('[data-av-bundle]').forEach((button) => button.addEventListener('click', () => {
      root.querySelectorAll('[data-av-bundle]').forEach((item) => item.classList.remove('is-active'));
      button.classList.add('is-active');
      if (quantity) quantity.value = button.dataset.avBundle;
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
